import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=6617cc6f"
import script from "./UserSettingsPage.vue?vue&type=script&lang=ts"
export * from "./UserSettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./UserSettingsPage.vue?vue&type=style&index=0&id=6617cc6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports